import React from 'react'

const AccountDetails = () => {
    return (
        <>
            <div className="acc-details">
                <p style={{ paddingLeft: "15px" }}>
                    <strong>Balance:</strong>0
                    &nbsp;&nbsp;&nbsp;
                    <strong>Equity:</strong> 0
                    &nbsp;&nbsp;&nbsp;
                    <strong>Margin:</strong>0
                    &nbsp;&nbsp;&nbsp;
                    <strong>Free Margin:</strong> 0
                    &nbsp;&nbsp;&nbsp;
                    <strong>Margin Level (%):</strong> 0
                </p>
            </div>
        </>
    )
}

export default AccountDetails
